module.exports = __webpack_public_path__ + "img/13.85f8a8ac.jpg";